export default __webpack_public_path__ + "static/media/400.e009e608.png";